import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const Lightbox = ({ src, onClose, testid = "lightbox" }) => (
  <Dialog open={!!src} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-[95vw] w-auto p-2 bg-white border-0 sm:rounded-md" data-testid={testid}>
      <DialogTitle className="sr-only">Image preview</DialogTitle>
      {src && <img src={src} alt="" className="max-h-[88vh] max-w-[90vw] w-auto h-auto mx-auto block" data-testid={`${testid}-image`} />}
    </DialogContent>
  </Dialog>
);
